// extracted by mini-css-extract-plugin
export default {"switcher-popover-theme":"Tx2d4QXQL78WPTkojygN","switcher-popover-content":"nGe_tQ8zn0P_bKOxDpDc"};